import { useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { FiMinusCircle } from "react-icons/fi";

const faqData = [
  {
    question: "Is there a free trial available?",
    answer: `You can sign up and use the service for free for a limited period before you need to choose a paid plan.`,
  },
  {
    question: "How does billing work?",
    answer: `You pay based on a plan you choose — typically monthly or yearly.
Each plan includes a set of features and usage limits.`,
  },
  {
    question: "Can I change my plan later?",
    answer: `You can upgrade or downgrade your plan at any time.`,
  },

  {
    question: "What is your cancellation policy?",
    answer: ` You will continue to have access to all features until your subscription expires.
`,
  },
  {
    question: "Can other info be added to an invoice?",
    answer: `Yes, additional information can be added to your invoice if needed. This may include your company name, address, tax details (like GST/VAT), purchase order number,`,
  },
  {
    question: "How does billing work?",
    answer: `Billing is processed based on the plan you choose. Payments are usually charged on a monthly or yearly basis.`,
  },
  {
    question: "How do I change my account email?",
    answer: `You can change your account email from your account settings. Go to Profile or Account Settings, update your email address, and save the changes.`,
  },
];

const Questions = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <div className="w-full px-4  md:px-20 mt-[10%] mb-5">
      <h2 className="font-clash font-medium text-3xl md:text-4xl text-center">
        Frequently Asked Questions
      </h2>
      <p className="font-aileron text-base md:text-lg text-gray-500 text-center mt-5">
        Everything you need to know about the product and services.
      </p>

      <div className="mt-10 flex flex-col gap-6 w-full">
        {faqData?.map((item, index) => (
          <div
            key={index}
            className="
        w-full 
        bg-white 
        rounded-xl 
        border border-gray-200 
        shadow-xl 
        transition-all duration-300 
        hover:shadow-[rgba(251,30,1,0.25)]
        md:max-w-[768px] 
        md:mx-auto
      "
          >
            <div
              className="flex justify-between items-center p-4 md:p-5 cursor-pointer"
              onClick={() => toggle(index)}
            >
              <h4 className="text-[16px] md:text-[20px] text-black font-clash">
                {item?.question}
              </h4>

              <span className="text-2xl text-black">
                {openIndex === index ? (
                  <FiMinusCircle />
                ) : (
                  <AiOutlinePlusCircle />
                )}
              </span>
            </div>

            <div
              className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ${
                openIndex === index ? "max-h-96 py-3" : "max-h-0"
              }`}
            >
              <p className="font-aileron text-[14px] md:text-[20px] text-[#667085] leading-relaxed">
                {item?.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Questions;
